<template>
    <div>
        <!-- Modal -->
        <v-dialog
            v-model="show"
            :persistent="persistent"
            :max-width="modalWidth"
            :scrollable="!(iconColor && iconName)"
        >
            <v-card
                :class="hasActions ? 'modal--tips4y' : 'modal--base-modal'"
                :style="cardBackgroundColor"
            >
                <v-card-title
                    :class="['headline', 'd-flex', 'justify-center', { 'no-title-padding': !title }]"
                >
                    <h2 v-if="title" class="mb-0" :style="modalTitleStyle">{{ title }}</h2>
                    <div class="icon-close">
                        <slot name="modal-close"></slot>
                    </div>
                </v-card-title>

                <v-card-text :style="[!scrolling ? { 'overflow-y': 'visible' } : '']">
                    <slot name="modal-body"></slot>
                    <template v-if="iconColor && iconName">
                        <v-icon
                            style="font-size: 5rem"
                            class="d-block text-center remove-pseudo-after"
                            :color="iconColor"
                        >
                            {{ iconName }}
                        </v-icon>
                    </template>
                </v-card-text>

                <v-card-actions
                    :class="hasActions ? `row-button ${justifyProp}` : 'd-none'"
                >
                    <slot name="modal-actions"></slot>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Modal -->
    </div>
</template>

<script>
/**
 * @params
 *
 * iconColor options: warning, success, error
 * iconName options: mdi-alert-outline, mdi-shield-check
 *
 */

export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        modalWidth: {
            type: String,
            default: "500px",
        },
        backgroundColor: {
            type: String,
            default: "white",
        },
        title: {
            type: String,
            default: "",
        },
        message: {
            type: String,
        },
        iconName: String,
        iconColor: String,
        modalAlign: String,
        hasActions: { type: Boolean, default: true },
        persistent: { type: Boolean, default: false },
        justifyProp: { type: String, default: "justify-center" },
        scrolling: {
            type: Boolean,
            default: true,
        },
        modalTitleStyle: { type: String, default: "" },
    },
    data() {
        return {
            configDefault: {
                show: false,
                texts: {
                    title: "Alterar",
                    message: "Deseja alterar para ...",
                },
            },
            show: false,
        };
    },
    computed: {
        cardBackgroundColor() {
            return `background-color: ${this.backgroundColor}`;
        },
    },
    methods: {
        closeModal() {
            this.$emit("input", !this.value);
        },
    },
    watch: {
        value: {
            handler: function (newValue, oldValue) {
                this.show = newValue;
                this.$emit("watch-show-value", newValue);
            },
            deep: true,
            immediate: true,
        },
        show: {
            handler: function (newValue, oldValue) {
                this.$emit("watch-show-value", newValue);
            },
            deep: true,
            immediate: true,
        },
    },

    mounted() {
        this.show = this.value;
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";

.v-dialog {
    border-radius: 25px !important;
    .modal--tips4y {
        .box__texts {
            padding: 10px 0;
            .row--texts {
                margin: 10px 0;

                .items-texts {
                    margin: 15px 0 20px;

                    p {
                        margin: 0 !important;
                        font-size: 14px;
                        font-family: Lato;
                        line-height: 1.1em;
                        font-weight: 400;
                        color: $grey-dark;

                        &:last-child {
                            font-size: 12px;
                            line-height: 1.1em;
                            color: $grey;
                        }
                    }
                }
            }
        }
    }
    .icon-close {
        position: absolute;
        top: 5px;
        right: 15px;
        cursor: pointer;
        z-index: 99999;
    }

    .danger-button {
        border: 1px solid #d90b3b;
        font-weight: 600;
        color: #d90b3b !important;
        border-radius: 43px;
        &:hover {
            background: #d90b3b;
            color: #fff !important;
        }
    }

    .info-button {
        border: 1px solid #d9a20b;
        font-weight: 600;
        color: #d9a20b !important;
        border-radius: 43px;
        &:hover {
            background: #d9a20b;
            color: #fff !important;
        }
    }
    .primary-button {
        border: 1px solid var(--v-primary-base);
        font-weight: 600;
        color: var(--v-primary-base) !important;
        border-radius: 43px;
        &:hover {
            background: var(--v-primary-base);
            color: #fff !important;
        }
    }
    .grey-button {
        border: 1px solid grey;
        font-weight: 600;
        color: grey !important;
        border-radius: 43px;
        &:hover {
            background: grey;
            color: #fff !important;
        }
    }
    .v-btn {
        min-width: 100px;
        &.v-btn--disabled {
            border-color: rgba(0, 0, 0, 0.26) !important;
        }
    }

    .no-title-padding {
        padding-top: 21px !important;
        padding-bottom: 21px !important;
    }
}
.row-button {
    @media (max-width: 425px) {
        display: inline-grid;
        text-align: center;
    }
}
</style>
